import type { TOffer } from 'shared/types/TRankingService';

import type { TPreApprovalResultItem } from './types';

export const updatePreApprovingOffer = (offer: TOffer, preApprovalResultMap: Map<string, TPreApprovalResultItem>) => {
  if (offer.id && preApprovalResultMap.has(offer.id)) {
    const offerResult = preApprovalResultMap.get(offer.id);
    if (offerResult) {
      const { offerView } = offerResult || {};
      const { groupItem } = offerView || {};
      const { summaries, isPreapproving, buttonLink, preApprovalOffer, badges, preApprovalStatus } = groupItem || {};
      return {
        ...offer,
        badges: (badges || offer.badges) as TOffer['badges'],
        summaries: summaries
          ? summaries.map((summary: any) => ({
              label: summary.text?.toString() || '',
              value: summary.value?.toString() || '',
            }))
          : offer.summaries,
        additionalInfo: {
          ...offer.additionalInfo,
          isPreapproving,
          buttonLink: preApprovalOffer?.link || buttonLink,
          referralLink: preApprovalOffer?.link || buttonLink,
        },
        preApprovalOffer: {
          ...offer.preApprovalOffer,
          ...preApprovalOffer,
        },
        preApprovalStatus: preApprovalStatus || offer.preApprovalStatus,
      };
    }
  }
  return offer;
};
